export default __webpack_public_path__ + "static/media/1854.088def4a.png";